import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ConvertDay' })
export class convertDayPipe implements PipeTransform {
    transform(value: any) {
        let character = '';
        switch (value) {
            case 1:
            case 'Mon':
                character = '月';
                break;
            case 2 :
            case 'Tue' :
                character = '火';
                break;
            case 3:
            case 'Wed':
                character = '水';
                break;
            case 4:
            case 'Thu':
                character = '木';
                break;
            case 5:
            case 'Fri':
                character = '金';
                break;
            case 6:
            case 'Sat':
                character = '土';
                break;
            case 0:
            case 'Sun':
                character = '日';
                break;
        }
        return character;
    }
}
